import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import { getAllCompanies } from 'store/slices/companies/companiesSlice';
import storage from 'services/utils/storage';
import { useDispatch, useSelector } from 'react-redux';
import '@inovua/reactdatagrid-community/index.css';
import { widgetCompaniesTableConfig } from 'services/utils/data-grid/tableConfig';
import { toast } from 'react-toastify';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { GridWrapper } from '../../../pub-components/GridWrapper';
import {
  getSelectedCompanies,
  setSelectedCompaniesToState
} from 'store/slices/widget-editor/widgetEditorSlice';
import { useTranslation } from 'react-i18next';
import useViewport from 'services/viewport-hook';
import { makeParamsFilters } from 'pub-components/GridWrapper/helper';
import { ToastTemplate } from 'services/utils/generic.methods';
import { useRouteMatch, useHistory } from 'react-router-dom';
import PageLoading from 'pub-components/page-loading';
export const dataKey = 'selected-companies-widgetSetting';

const useStyles = makeStyles(theme => ({
  companiesContainer: {
    // display: ({ isMobile }) => (isMobile ? 'none' : 'block !important')
  }
}));
const Companies = () => {
  const [selectedData, setSelectedData] = useState({});
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(false);
  const selectedCompanies = useSelector(getSelectedCompanies);

  const [vissibleColumns, setVissibleColumns] = useState(null);
  const [selectedFilters] = useState(null);
  const screen = useViewport();
  const classes = useStyles({ isMobile: screen.xs });

  const { path, url } = useRouteMatch();
  const history = useHistory();
  // initialize selected Tab Data after Redirect From other screen
  useEffect(() => {
    let data = JSON.parse(storage.getItem(dataKey)) || [];
    setSelectedData(generateSelected(data));
    dispatch(setSelectedCompaniesToState(data));
  }, []);

  useEffect(() => {
    setSelectedData(generateSelected(selectedCompanies));
  }, [selectedCompanies]);

  // initialize selected Tab Data after Redirect From other screen
  useEffect(() => {
    let selected = JSON.parse(storage.getItem(dataKey));
    if (selected && selected.length) {
      viewDetail(selected[0]?.id);
    }
  }, []);

  // select Company
  const handleSelect = payload => {
    console.log('handleselect', payload, url);
    let selectedCompany = payload.data[0];
    updateCompaniesAndSaveToLS(payload.data);
    let companyId = selectedCompany?.id;
    viewDetail(companyId);
  };

  const viewDetail = companyId => {
    // change route here route.push(`url/${companyId}/widget-editor`)
    history.push(`${url}/${companyId}/widget-editor`);
  };

  //  update Selected Companies and save to Local Storage
  const updateCompaniesAndSaveToLS = payload => {
    setSelectedData(payload);
    dispatch(setSelectedCompaniesToState(payload));
  };

  const generateSelected = arrayData => {
    return arrayData.reduce(
      (obj, item) => ({
        ...obj,
        [item['id']]: item
      }),
      {}
    );
  };

  const loadData = ({ skip, limit, sortInfo, filterValue }) => {
    try {
      setLoadingMessage('Loading ...');
      const updatedValue = makeParamsFilters(filterValue);
      let payload = {
        start: skip,
        limit: limit,
        filter: updatedValue,
        dir: !sortInfo ? 'DESC' : sortInfo.dir === 1 ? 'ASC' : 'DESC',
        sort: sortInfo ? sortInfo.name : 'createdOn'
      };
      return getAllCompanies(payload).then(response => {
        if (response.data.totalSize > 20) {
          setDataLimit(skip + response.data.data.length);
        } else {
          setDataLimit(response.data.data.length);
        }
        const totalCount = response.data.totalSize;

        storage.setItem('companiesCount', totalCount);

        setTotalRecords(totalCount);
        if (!JSON.parse(updatedValue).length) {
          if (totalCount === 1) {
            let singleCompany = response.data.data[0];
            updateCompaniesAndSaveToLS([singleCompany]);
            // if only one company available then view it directly
            viewDetail(singleCompany?.id);
          }
        }
        return { data: response.data.data, count: parseInt(totalCount) };
      });
    } catch (error) {
      toast.error(ToastTemplate.error(error || error.message));
    }
  };

  const dataSource = useCallback(loadData, []);
  const [dataLimit, setDataLimit] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState('Loading ...');

  const renderColumnContextMenu = useCallback((menuProps, { cellProps }) => {
    menuProps.items = menuProps.items.splice(0, 8);
  }, []);

  const handleColumnsChange = data => {
    setVissibleColumns({ ...data });
  };
  return (
    <>
      {loading && <PageLoading />}
      <div
        className={`pr-2 pl-2 ${classes.companiesContainer}`}
        hidden={loading}
      >
        <Row>
          <Col className="m-3">
            <h2>
              Settings&nbsp;
              <Badge variant="primary p-1 badge-align">
                {loading ? '...' : `${dataLimit} / ${totalRecords}`}
              </Badge>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className={loading && 'blux-text'}>
            <div className="mobile_view">
              <GridWrapper
                refetch={refetch}
                // checkboxOnlyRowSelect={true}
                // checkboxColumn={true}
                customGridStyle={{ minHeight: 'calc(100vh - 170px)' }}
                columns={widgetCompaniesTableConfig()}
                totalRecords={totalRecords}
                dataSource={dataSource}
                setLoading={setLoading}
                loadingMessage={loadingMessage}
                renderColumnContextMenu={renderColumnContextMenu}
                selectedData={selectedData}
                handleSelect={handleSelect}
                vissibleColumns={vissibleColumns}
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default React.memo(Companies);
